angular.module('rjmNg.directives').directive "userselect", [
  "dashboardService"
  "app"
  "enums"
  (dashboardService, app, enums) ->
    restrict: "E"
    templateUrl: "directive.userSelect.html"
    replace: true
    scope:
      users: "="
      readOnly: "="
      onToggle: "&"
    link: (scope, elem, attrs) ->

      scope.multiSelect = false
      if app.isAumEnabled()
        scope.bulkActionPermissionNames = [
          {id: enums.DASHBOARD_PERMISSION.NONE, name: 'None'}
          {id: enums.DASHBOARD_PERMISSION.VIEW, name: 'View'}
        ]
      else
        scope.bulkActionPermissionNames = [
          {id: enums.DASHBOARD_PERMISSION.NONE, name: 'None'}
          {id: enums.DASHBOARD_PERMISSION.VIEW, name: 'View'}
          {id: enums.DASHBOARD_PERMISSION.EDIT, name: 'Edit'}
        ]
      scope.permissionNames = [{id: enums.DASHBOARD_PERMISSION.NONE, 'name':'None'},{id: enums.DASHBOARD_PERMISSION.VIEW, name:'View'},{id: enums.DASHBOARD_PERMISSION.EDIT, 'name':'Edit'}]
      scope.searchText = {}
      scope.searchText.$ = ''
      scope.currentUser = app.getUser()

      scope.filteredPermissionNames = scope.permissionNames.filter (p) ->
        return p.id != enums.DASHBOARD_PERMISSION.EDIT

      scope.getPermissionName = (id) ->
        return scope.permissionNames[id].name

      scope.toggleUser = (user) ->
        if user.id isnt app.getUserId()
          user.selected = not user.selected
          scope.onToggle()

      scope.toggleAll = (multiSelect) ->
        user.selected = not user.selected for user in scope.users when user.id isnt app.getUserId()
        scope.onToggle()

      scope.bulkAction = (permissionLevel) ->
        user.permission = permissionLevel for user in scope.users when user.selected
        scope.onToggle()

      scope.hasEditRights = (user) ->
        return user.permission is enums.DASHBOARD_PERMISSION.EDIT

      scope.selectAll = ->
        user.selected = true for user in scope.users when user.id isnt app.getUserId()
        scope.onToggle()

      # Select only users we can see in the current search
      scope.selectAllVisible = ->
        for user in scope.users
          if (user.name?.toLowerCase().indexOf scope.searchText.$.toLowerCase()) >= 0 or (user.email?.toLowerCase().indexOf scope.searchText.$.toLowerCase()) >= 0 # Using javascript's indexOf function
            if user.id isnt app.getUserId()
              user.selected = true
        scope.onToggle()

      scope.unselectAll = ->
        user.selected = false for user in scope.users when user.id isnt app.getUserId()
        scope.onToggle()

]
